import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noteInputLabel: {
    id: 'buGr06',
    description: 'Label for the note input field',
    defaultMessage: 'Internal Notes',
  },
  noteInputPlaceholder: {
    id: 'LeT5XH',
    description: 'Placeholder text for the note input field',
    defaultMessage: 'Add a note...',
  },
  addNoteButton: {
    id: '1u+jSq',
    description: 'Text of the add note button',
    defaultMessage: 'Add',
  },
  requestNoteCreateErrorTitle: {
    description: 'Error title when return note creation fails',
    defaultMessage: 'There was an error adding your note. Please try again later.',
    id: 'pdAA/T',
  },
  requestNoteCreateSuccessTitle: {
    description: 'Success title when return note is created',
    defaultMessage: 'Note added successfully.',
    id: '1xW6zv',
  },
});
